import { render } from "./action-instagram-posts.vue?vue&type=template&id=50f72e50"
import script from "./action-instagram-posts.vue?vue&type=script&lang=js"
export * from "./action-instagram-posts.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__